<template>
  <div class="popup">
    <Drawer v-if="openType=='drawer'" :title="title" :width="width" closable v-model="show"
            @on-visible-change="onVisibleChange">
      <slot></slot>
    </Drawer>
    <Modal
      v-if="openType=='modal'"
      v-model="show"
      :title="title"
      :width="width"
      :mask-closable="maskClosable"
      :closable="closable"
      @on-visible-change="onVisibleChange"
      :footer-hide="footerHide"
      :lock-scroll="lockScroll"
      :draggable="draggable"
      sticky
    >
      <slot></slot>
      <template slot="footer">
        <i-button size="large" type="text" @click.native="onCancel">取消</i-button>
        <i-button size="large" type="primary" @click.native="onOk">{{ okText }}</i-button>
      </template>
    </Modal>
  </div>
</template>

<script>
/**
 *  @description: 抽屉,对话框,弹窗组件
 *  @author: 刘雷
 *  @time: 2022-06-07 16:09:50
 */
export default {
  name: "popup",
  data() {
    return {
      show: false
    }
  },
  props: {
    openType: {//多个弹窗类型
      type: String,
      default: 'drawer'
    },
    title: {
      type: String,
      default: '查看详情'
    },
    width: {
      type: Number,
      default: 40
    },
    footerHide: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: '确定'
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    draggable: {
      type: Boolean,
      default: true
    },
    isReset: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    open() {//外部调用函数
      this.show = true;
    },
    close() {//外部调用函数
      this.show = false;
    },
    onOk() {
      this.$emit('on-ok');
    },
    onCancel() {
      this.show = false;
      this.$emit('on-cancel');
    },
    onVisibleChange(e) {
      if (!e && this.isReset) {
        Object.assign(this.$parent.$data, this.$parent.$options.data());
      }
      this.$emit('on-visible-change', e);
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ivu-modal-body {
  padding-top: 10px;
}

.popup {

}
</style>
